// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isObject(val: unknown): val is Record<string, any> {
    return typeof val === 'object' && val !== null;
}
